/**
 * Dialog window to check if user is still online when his session is about to expire
 */
(function ($) {
    $.widget('ca.caSessionExpirationWindow', {
        options: {
            expirationDelaySeconds: 60,
            intervalToDoCheck: 5000,
            popupDisplayed: false
        },

        expireTimer: '',

        _create: function () {
            this.checkTime();
        },

        checkTime: function () {
            var that = this;
            var isLoggedIn = that.getCookie('isLoggedIn');
            if (!isLoggedIn) {
                return;
            }
            if (that.isTimeToShowPopup()) {
                if (!that.options.popupDisplayed) {
                    // show popup
                    that.options.popupDisplayed = true;
                    that.showPopup();
                }
            } else {
                // if window is active - close it because time is correct
                if (that.options.popupDisplayed) {
                    clearInterval(that.expireTimer);
                    that.options.popupDisplayed = false;
                    $('#confirm-dialog').caConfirm('close');
                }
            }

            // check again after interval
            setTimeout(
                function () {
                    that.checkTime();
                },
                that.options.intervalToDoCheck
            );
        },

        getPopupShowTime: function () {
            var that = this;
            // PHP format of timestamp does not have microseconds. Need to multiply.
            var sessionExpirationTime = new Date(that.getCookie('SessionExpirationTime') * 1000);
            // deduct amount ot minutes from expiration date to find out time to show popup
            sessionExpirationTime.setSeconds(
                sessionExpirationTime.getSeconds() - that.options.expirationDelaySeconds
            );
            return sessionExpirationTime.getTime();
        },

        showPopup: function () {
            var that = this;
            var timerDiv = '<div><h2 id="session_expiration_timer">' + that.options.expirationDelaySeconds + '</h2></div>';

            $.caConfirm(
                'You are about to be logged out of Club Automation due to inactivity. Would you like to remain logged in?' + timerDiv,
                '',
                'Yes',
                'No',
                function () {
                    that.remainActive();
                },
                function () {
                    that.logout(true);
                },
                {
                    showCloseButton: false
                }
            );

            this.showTimer();
        },

        showTimer: function () {
            var that = this;
            var secondsRemaining = that.options.expirationDelaySeconds;
            that.expireTimer = setInterval(function () {
                var timerExist = $('#session_expiration_timer');
                if (!timerExist) {
                    return;
                }
                secondsRemaining--;
                timerExist.text(secondsRemaining);
                if (secondsRemaining <= 0) {
                    that.logout();
                    clearInterval(that.expireTimer);
                }
            }, 1000);
        },

        isTimeToShowPopup: function() {
            var nowTime = new Date().getTime();
            var popupShowTime = this.getPopupShowTime();
            return (isNaN(popupShowTime) || nowTime >= popupShowTime);
        },

        isSessionExpired: function() {
            var that = this;
            var nowTime = new Date().getTime();
            var sessionExpirationTime = new Date(that.getCookie('SessionExpirationTime') * 1000);
            sessionExpirationTime = sessionExpirationTime.getTime();
            return (isNaN(sessionExpirationTime) || nowTime >= sessionExpirationTime);
        },

        logout: function (forceLogout) {
            var that = this;
            if (!that.isSessionExpired() && !forceLogout) {
                return;
            }
            window.location.replace("/user/logout");

            return false;
        },

        remainActive: function () {
            var that = this;
            $.caPost(
                '/index/update-session-expiration',
                null,
                function (response) {
                    if (response.status == 1) {
                        that.options.popupDisplayed = false;
                        clearInterval(that.expireTimer);
                    }
                }
            );
        },

        getCookie: function (name) {
            var match = document.cookie.match(new RegExp(name + '=([^;]+)'));
            if (match) return match[1];
        }
    });
})(jQuery);

